/* istanbul ignore file */
import IpcaAdjustmentModal from './IpcaAdjustmentModal';

export default IpcaAdjustmentModal;
